import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useReddyAuth } from './ReddyAuth';
import AccountMenu from './AccountMenu';

const TICKER = [
  'Manchester Super Giants W v Trent Rockets W',
  'Northamptonshire v Leicestershire',
  'Yorkshire v Durham',
  'Essex v Hampshire',
  'The Hundred - Womens',
  'The Hundred',
  'Kent v Somerset',
  '🏎️ DUTCH GRAND PRIX 🏁 - RACE',
];

export default function Header({ onLogin, onSignup, onToggleDrawer }) {
  const navigate = useNavigate();
  const { user } = useReddyAuth();
  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="container d-flex align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <a href="/" className="logo d-flex align-items-center" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
            {/* brand logo image; on error, fall back to the "REDDY ANNA BOOK" text placeholder */}
            <img
              className="img-fluid reddy-header-logo"
              src="/images/reddy/reddybook-logo.png"
              alt="Reddy Anna Book"
              onError={(e) => {
                const el = e.currentTarget;
                el.style.display = 'none';
                const ph = document.createElement('span');
                ph.className = 'reddy-logo-ph';
                ph.innerHTML = 'REDDY <b>ANNA BOOK</b>';
                if (el.parentNode) el.parentNode.appendChild(ph);
                el.onerror = null;
              }}
            />
          </a>
          {/* hamburger — hidden on desktop, fixed top-right on mobile (@media); opens the drawer */}
          <i className="bi bi-list-nested toggle-sidebar-btn" role="button" aria-label="Menu" onClick={onToggleDrawer} />
        </div>
        <div className="livematch">
          <span className="lm_icon"><i className="bi bi-megaphone" /></span>
          <marquee scrollamount="5" className="lm_datas">
            {TICKER.map((t, i) => <div key={i}><b tabIndex={0}>{t}</b></div>)}
          </marquee>
        </div>
        <div className="search-bar">
          <form method="POST" action="#" className="search-form d-flex align-items-center" onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="Search Events" className="form-control" aria-label="Search Events" />
            <button type="submit" title="Search"><i className="bi bi-search" /></button>
          </form>
        </div>
        <a href="/rules" className="rules" onClick={(e) => { e.preventDefault(); navigate('/rules'); }}>rules</a>
        <nav className="header-nav ms-auto">
          <ul className="d-flex">
            {user ? (
              <AccountMenu user={user} />
            ) : (
              <li className="nav-item dropdown pe-3">
                <a className="btn-login" href="/register" onClick={(e) => { e.preventDefault(); onSignup ? onSignup() : navigate('/register'); }}>Signup</a>
                <a className="btn-login" href="/login" onClick={(e) => { e.preventDefault(); onLogin ? onLogin() : navigate('/login'); }}>Login</a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}
